import { render, staticRenderFns } from "./yqfx.vue?vue&type=template&id=4f8e7d63&"
import script from "./yqfx.vue?vue&type=script&lang=js&"
export * from "./yqfx.vue?vue&type=script&lang=js&"
import style0 from "./yqfx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports